import { render } from "./MaintenancesPage.vue?vue&type=template&id=357e807a&scoped=true"
import script from "./MaintenancesPage.vue?vue&type=script&lang=js"
export * from "./MaintenancesPage.vue?vue&type=script&lang=js"

import "./MaintenancesPage.vue?vue&type=style&index=0&id=357e807a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-357e807a"]])

export default __exports__